import { ProductLine, getAccessibilityScript } from '@adc/ui-adc'

const ENV = {
  local: 'local',
  ci: 'ci',
  qa: 'qa',
  prod: 'prod',
}

// TODO: fetch these from server somehow (graph?)
const siteKeys = {
  [ProductLine.SmartSale]: {
    [ENV.local]: '99cbe4ecea4ae54c0d300f0f14573cc7',
    [ENV.ci]: '7b7aba4c1cce82a4b9cde7a2b7bbcd7c',
    [ENV.qa]: '7e637df859d0e78cdbd0125baa281851',
    [ENV.prod]: '8c338af8fa7071f315018132339eebb1',
  },
  [ProductLine.AuctionCom]: {
    [ENV.local]: '99cbe4ecea4ae54c0d300f0f14573cc7',
    [ENV.ci]: '9cd3e4edcc3f3625c26a82a34a787ce2',
    [ENV.qa]: 'f3de7e5eaa4291ab8a3b0d201a040700',
    [ENV.prod]: '9878a171444805911abae51889b9f024',
  },
}

function getSiteKey(productLine, env) {
  return siteKeys?.[productLine]?.[env] || null
}

function getAccessibilityOptions(productLine, env) {
  const options = {
    equalweb: {
      is_enabled: true,
    },
  }
  const siteKey = getSiteKey(productLine, env)
  if (siteKey) {
    options.equalweb.site_key = siteKey
  } else {
    options.equalweb.is_enabled = false
  }
  return options
}

function initializeAccessibilityTool() {
  if (window.CONFIGS?.accessibility?.equalweb?.is_enabled) {
    const script = document.createElement('script')
    script.id = 'adc-injection'
    script.type = 'module'
    script.defer = 'true'
    script.innerHTML = getAccessibilityScript(
      window.CONFIGS.accessibility?.equalweb
    ) // eslint-disable-line
    document.head.appendChild(script)
  }
}

/**
 * Initializes the DropKit with the appropriate configuration based on the product line.
 * Placed on the window object for easy access inside the HTML.
 *
 * TO DO: figure out a way to pull actual CONFIG values from server (perhaps via graph)
 *
 * @param {ProductLine} productLine The product line to initialize the DropKit with.
 * This is optional, if not passed, we look at the origin
 */
function initializeDropKit(productLineOverride) {
  productLineOverride = (productLineOverride || '').toLowerCase()
  window.CONFIGS = {
    APP_NAME: 'dropkit',
  }
  window.STATE = {}
  const origin = window.location.origin

  const productLine =
    productLineOverride ||
    (origin.includes('smartsale')
      ? ProductLine.SmartSale
      : ProductLine.AuctionCom)

  // Determine the environment
  let env = ENV.prod // Default to 'prod'
  if (origin.includes('localhost') || origin.includes('cluster.dev.aucn.io')) {
    env = ENV.local
  } else if (origin.startsWith('https://ci.')) {
    env = ENV.ci
  } else if (origin.startsWith('https://qa.')) {
    env = ENV.qa
  }

  // determine AUCTIONCOM_HOST / SMARTSALE_HOST
  window.CONFIGS.AUCTIONCOM_HOST = 'https://www.auction.com'
  window.CONFIGS.SMARTSALE_HOST = 'https://www.smartsale.com'
  if (env === ENV.local) {
    window.CONFIGS.AUCTIONCOM_HOST = 'http://cluster.dev.aucn.io'
    window.CONFIGS.SMARTSALE_HOST = 'http://cluster.dev.aucn.io'
  } else if (env === ENV.ci) {
    window.CONFIGS.AUCTIONCOM_HOST = 'https://ci.auction.com'
    window.CONFIGS.SMARTSALE_HOST = 'https://ci.smartsale.com'
  } else if (env === ENV.qa) {
    window.CONFIGS.AUCTIONCOM_HOST = 'https://qa.auction.com'
    window.CONFIGS.SMARTSALE_HOST = 'https://qa.smartsale.com'
  }

  // determine GRAPH_API_URL and APP_THEME
  if (productLine === ProductLine.SmartSale) {
    window.CONFIGS.RESI_GRAPH_API_URL = 'https://graph.smartsale.com'
    if (env === ENV.local) {
      window.CONFIGS.RESI_GRAPH_API_URL = 'http://graph.dev.aucn.io'
    } else if (env === ENV.ci || env === ENV.qa) {
      window.CONFIGS.RESI_GRAPH_API_URL = origin.replace(
        /\/(ci|qa)(\.)/g,
        '/graph.$1$2'
      )
    }
    window.CONFIGS.APP_THEME = ProductLine.SmartSale
  } else {
    // auctioncom
    window.CONFIGS.RESI_GRAPH_API_URL = 'https://graph.auction.com'
    if (env === ENV.local) {
      window.CONFIGS.RESI_GRAPH_API_URL = 'http://graph.dev.aucn.io'
    } else if (env === ENV.ci || env === ENV.qa) {
      window.CONFIGS.RESI_GRAPH_API_URL = origin.replace(
        /\/(ci|qa)(\.)/g,
        '/graph.$1$2'
      )
    }
    window.CONFIGS.APP_THEME = ProductLine.AuctionCom
  }

  window.CONFIGS.RESI_GRAPH_API_WS_URL_EXTERNAL =
    window.CONFIGS.RESI_GRAPH_API_URL.replace('http', 'ws')
  window.CONFIGS.RESI_GRAPH_API_SUBSCRIPTIONS_URL =
    window.CONFIGS.RESI_GRAPH_API_URL.replace('http', 'ws')
  console.log('Configured window.CONFIGS with', window.CONFIGS) // eslint-disable-line no-console

  // load equalweb
  window.CONFIGS.accessibility = getAccessibilityOptions(productLine, env)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeAccessibilityTool()
    })
  } else {
    initializeAccessibilityTool()
  }
}

window.initializeDropKit = initializeDropKit
